export const ROLES = Object.freeze({
  USER: 'user',
  ADMIN: 'admin',
  SUB_ADMIN: 'sub_admin',
  BROKER: 'broker',
});

export const ROLES_TYPE = [
  { label: "User", value: ROLES.USER },
  { label: "Broker", value: ROLES.BROKER },
  { label: "Sub Admin", value: ROLES.SUB_ADMIN },
  { label: "Admin", value: ROLES.ADMIN },
]

export const userPageType = Object.freeze({
  VIEW: "VIEW",
  UPDATE: "UPDATE",
});

export const USER_TYPE = Object.freeze({
  ACTIVE: "Active",
  INACTIVE: "Inactive",
  SELECTSTATUS: "Select Status",
});

export const percentMode = Object.freeze({
  PERCENTAGE: "percentage",
  FIXED: "fixed",
});

export const activeStatus = Object.freeze({
  ACTIVE: true,
  INACTIVE: false,
});

export const blogCategories = Object.freeze({
  TECHNICAL: "technical",
  LIFESTYLE: "lifestyle",
  FINANCE: "finance",
});

export const CATEGORY = Object.freeze({
  TECHNICAL: "technical",
  LIFESTYLE: "lifestyle",
  FINANCE: "finance",
});

export const CURRENCY = Object.freeze({
  DOLLAR: "dollar",
  INR: "inr",
});

export const PLATFORM_TYPE = Object.freeze({
  ICO: "ico",
  TRAVEL: "travel",
});

export const PAGE_TYPE = Object.freeze({
  ABOUT_US: "about-us",
  TERMS_AND_CONDITIONS: "terms-and-conditions",
  PRIVACY_POLICY: "privacy-policy",
  HOME_PAGE_STATICS: "home-page-statics",
});

export const CMS_WEBSITE_TYPE = Object.freeze({
  ICO: "ico",
  TRAVEL: "travel",
});

export const HOTEL_PAX = Object.freeze({
  AD: "ADULT",
  CH: "CHILD",
});

export const TRANSACTION_TYPE = Object.freeze({
  ALL: "all",
  DEBIT: "debit",
  CREDIT: "credit",
  SETTLEMENT: "settlement",
  TRANSFER: "transfer",
})

export const TRANSACTION_TYPE_OPTIONS = [
  { label: "All Transactions", value: TRANSACTION_TYPE.ALL },
  { label: "Debit", value: TRANSACTION_TYPE.DEBIT },
  { label: "Credit", value: TRANSACTION_TYPE.CREDIT },
  { label: "Settlement", value: TRANSACTION_TYPE.SETTLEMENT },
  { label: "Transfer", value: TRANSACTION_TYPE.TRANSFER },
]

